import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const SearchRepeatIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 19.4984 19.4984">
            <path
                d="M8.88186 0.790058C10.5094 0.63609 12.1482 0.927781 13.6227 1.63389M0.790092 8.88198C0.636051 10.5096 0.927713 12.1484 1.63383 13.6229M5.32327 1.91962C3.89453 2.71605 2.71588 3.89471 1.91946 5.32344M16.1123 3.38437C19.627 6.89911 19.627 12.5976 16.1123 16.1124C12.5976 19.6271 6.89904 19.6271 3.3843 16.1124M14.4775 14.4775L11.7962 11.7961M6.24843 9.49837C6.24843 11.2933 7.70351 12.7484 9.49843 12.7484C11.2934 12.7484 12.7484 11.2933 12.7484 9.49837C12.7484 7.70345 11.2934 6.24837 9.49843 6.24837C7.70356 6.2485 6.24856 7.7035 6.24843 9.49837Z"
                fill="none"
                stroke="var(--iconFill)"
                strokeWidth="1.5"
            />
        </SvgIcon>
    );
};
import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const SearchRepeatIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 19.4984 19.4984">
            <path
                d="M8.88186 0.790058C10.5094 0.63609 12.1482 0.927781 13.6227 1.63389M0.790092 8.88198C0.636051 10.5096 0.927713 12.1484 1.63383 13.6229M5.32327 1.91962C3.89453 2.71605 2.71588 3.89471 1.91946 5.32344M16.1123 3.38437C19.627 6.89911 19.627 12.5976 16.1123 16.1124C12.5976 19.6271 6.89904 19.6271 3.3843 16.1124M14.4775 14.4775L11.7962 11.7961M6.24843 9.49837C6.24843 11.2933 7.70351 12.7484 9.49843 12.7484C11.2934 12.7484 12.7484 11.2933 12.7484 9.49837C12.7484 7.70345 11.2934 6.24837 9.49843 6.24837C7.70356 6.2485 6.24856 7.7035 6.24843 9.49837Z"
                fill="none"
                stroke="var(--iconFill)"
                strokeWidth="1.5"
            />
        </SvgIcon>
    );
};
